import { RootState } from '..';

export const userLocation = (state: RootState) => state.location;
